import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ITestRepository from '../../2_domain/test/iTestRepository';
import { TestStatusDto, TestSummary } from '../../2_domain/test/test';
import Get from '../../lib/di/get';
import { toKRString } from '../../lib/util/dateFormatter';
import promiseResolver from '../../lib/util/promiseResolver';

const EmptyTestSummaryPageResult: PageResult<TestSummary> = {
  list: [],
  page: {
    pageNumber: 0,
    totalElements: 0,
  },
};

const useTestDoneBoardControl = (
  fromDate: Date | undefined,
  endDate: Date | undefined,
  statusDone: TestStatusDto
) => {
  const testRepo = Get.find<ITestRepository>('ITestRepository');

  const [testSummary, setTestSummary] = useState(EmptyTestSummaryPageResult);
  const navigate = useNavigate();

  const navigateToTestList = () =>
    navigate(
      `../test/check?status=${encodeURIComponent(statusDone.status)}${
        fromDate ? `&from=${toKRString(fromDate)}` : ''
      }${endDate ? `&end=${toKRString(endDate)}` : ''}`
    );

  const navigateToTestId = (id: number) => () => navigate(`../test/${id}`);

  const [loading, setLoading] = useState(false);
  const loadTestSummary = () => {
    promiseResolver({
      promise: testRepo.getTestDoneSummary(
        statusDone?.status,
        fromDate,
        endDate
      ),
      successCallback: (data) => {
        setTestSummary(data);
      },
      isLoadingCallback: setLoading,
    });
  };

  useEffect(() => {
    loadTestSummary();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fromDate, endDate]);

  return {
    loading,
    navigateToTestList,
    testSummary,
    navigateToTestId,
  };
};

export default useTestDoneBoardControl;
